import React from 'react'
import { Link, graphql } from 'gatsby'
import '../layouts/tachyons/css/tachyons.css';
import '../layouts/custom.css';
import { Title1, Title2, Title3, Large, Medium, Small, Tiny, Micro, BuddyLink } from "../components/typography"
import { Divider, SectionFeatured, SectionOuter, SectionContact, SectionTestimonial, SectionFeaturedWork, SectionWork, NavLink, NavLinkList, FooterLink, FooterLinkList, SectionAboutHero, WorkList, WorkListClient, WorkListEnd } from "../components/section"
import Footer from '../components/footer'
import Navigation from '../components/navigation'
import Fade from 'react-reveal/Fade';
import ScrollableAnchor from 'react-scrollable-anchor'
import { configureAnchors } from 'react-scrollable-anchor'
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { withPrefix } from 'gatsby'
import SEO from "../components/seo"

configureAnchors({scrollDuration: 800, keepLastAnchorHash:false})

class Etobee extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            visibility: false,
            categorie: "fl mr3 flex flex-m h0 height-animation-in",
            textButton: "No",
            show: false
          };
        // change code below this line
        this.addClassName = this.addClassName.bind(this);
        // change code above this line
      }

      addClassName() {
        if (this.state.visibility == true) {
            this.setState({
                visibility: false,
                categorie: "fl mr3 flex flex-m h0 height-animation-in",
                textButton: "No",
                show: false

            });} else {
              this.setState({
                visibility: true,
                categorie: "fl mr3 flex flex-m h3point5 height-animation-out",
                textButton: "Yes",
                show: !this.state.show 
              })
            }
      }

    render() { 
      return (
        <div>
            <SEO title="Work: Etobee" keywords={[`product designer`, `product strategist`, `UI Design`,`User Experience` ,`UX Designer Jakarta`]} />
            <Navigation/>
            <SectionOuter className="ph6-ns pt6-ns pb0-ns ph5-m ph4 pt5 pb3 w-90-ns w-100-m">
                    <Large className="mb4-ns mb2-m pb2-m mt3 mt3-m mt0-ns pt5 pt0-m pt0-ns">Show more projects : <button onClick={this.addClassName} className="f3-ns fw5 mb0 mt0 sans-serif c--grey1 showproject">{this.state.textButton}</button></Large>
            </SectionOuter>

            <SectionFeaturedWork>
            <SectionOuter>
            <Fade right duration={900} when={this.state.show}>
                <div className={this.state.categorie}>

                    <AniLink cover to="bukalapak#section1" bg="#D21F4F" direction="down" duration={0.8}>
                        <div className="w5-ns h3-ns w5-m h3-m w5 h3 bg-bukalapak mr3 ph3 pb3 flex items-end br3 dim">
                            <Medium className="sans-serif fw6 white mb0 ml2">Bukalapak</Medium>
                        </div>
                    </AniLink>

                    <AniLink cover to="skillshare#section1" bg="#18C5CB" direction="down" duration={0.8}>
                        <div className="w5-ns h3-ns w5-m h3-m w5 h3 bg-skillshare mr3 ph3 pb3 flex items-end br3 dim">
                            <Medium className="sans-serif fw6 white mb0 ml2">Skillshare</Medium>
                        </div>
                    </AniLink>

                    <AniLink cover to="yors#section1" bg="#19D1C2" direction="down" duration={0.8}>
                        <div className="w5-ns h3-ns w5-m h3-m w5 h3 bg-yors mr3 ph3 pb3 flex items-end br3 dim">
                            <Medium className="sans-serif fw6 white mb0 ml2">Yors</Medium>
                        </div>
                    </AniLink>

                    <AniLink cover to="stickearn#section1" bg="#503680" direction="down" duration={0.8}>
                        <div className="w5-ns h3-ns w5-m h3-m w5 h3 bg-stickearn mr3 ph3 pb3 flex items-end br3 dim">
                            <Medium className="sans-serif fw6 white mb0 ml2">Stickearn</Medium>
                        </div>
                    </AniLink>

                    <AniLink cover to="dribbble" bg="#ea4c89" direction="down" duration={0.8}>
                        <div className="w5-ns h3-ns w5-m h3-m w5 h3 bg-dribbble mr3 ph3 pb3 flex items-end br3 dim">
                            <Medium className="sans-serif fw6 white mb0 ml2">Dribbble Shots</Medium>
                        </div>
                    </AniLink>
                </div>
            </Fade>  
            </SectionOuter> 
            </SectionFeaturedWork>

            <ScrollableAnchor id={'section1'}>
                <SectionWork className="etobee mt4-ns mt3-m mt2 pv5">
                <SectionOuter>
                    <Fade top duration={800} distance={"3em"} delay={300} >
                        <Large className="fw6 white mt5-ns">Etobee</Large>
                    </Fade>
                    <Fade top duration={800} distance={"3em"} delay={600} >
                        <Title1 className="white mt3 mb4 measure-narrow">Designing an MVP for the future of urban logistics and last-mile delivery service</Title1>
                    </Fade>
                    <Fade top duration={800} distance={"3em"} delay={800} >
                        <Tiny className="white mb4-ns mb0-m ">User Experience Design &#183; Interface Design &#183; Front-end development &#183; Brand &amp; Marketing Design</Tiny>
                    </Fade>
                </SectionOuter>
                </SectionWork>
            </ScrollableAnchor>

            <SectionOuter className="pt6-ns pb5-ns w-100-ns pt5-m pb4-m pt4 pb3">
                <Fade bottom duration={800} distance={"2em"}>
                    <article className="w-40-ns w-100-m tl fl pr5-ns pb4-ns pb4-m pb3 mb2">
                        <Large>Etobee was born in 2015 as a technology company to solve all the complexities and problems in logistics.</Large>
                    </article>
                    <article className="w-60-ns w-100-m fr mt0-ns fw3">
                        <Medium className="inconsolata alt-monospace fw3">E-commerce growth drives the logistics and supply chain industries to grow and digitally transformed. Sven Milder, our founder, has the vision to change the face of urban logistics and last-mile shipments for online stores by applying technology to provide value that has never existed before. Technology enables Etobee to provide speed and control for their customers with on-demand service and other features such as real-time tracking, ease of payment, and paperless transactions. <br/><br/> I joined Etobee amid their preparation to launch their MVP.  It was chaotic, as you have imagined, a startup in the middle of the process of turning an idea into a product. I was involved in various jobs, from research, design product and marketing to development.</Medium>
                    </article>
                </Fade>
                <div className="cf"></div>
            </SectionOuter>

            <SectionOuter className="pt3-ns pb5-ns mb4-ns pt0-m pb4-m pt0 pb4 w-100-ns mt3-m">
                <Fade bottom duration={800} distance={"2em"}>
                <img src={withPrefix('/img/etobee/etobee1.jpg')} className="pv3 db no-underline black"/>
                </Fade>
            </SectionOuter>

            <SectionOuter><Divider/></SectionOuter>

            <SectionOuter className="pt5-ns pb4-ns w-100-ns pv4-m pt3 pb3">
                <Fade bottom duration={800} distance={"2em"}>
                    <article className="w-40-ns w-100-m tl fl pr5-ns pb4-ns pb2-m pb0">
                        <Title3 className="mb4">A mobile app for customers.</Title3>
                    </article>
                    <article className="w-60-ns w-100-m fr mt0-ns fw3">
                        <Medium className="inconsolata alt-monospace fw3">Having a little time and questioning a lot of things, we strove on designing the MVP for the customer app. The deeper we tried to understand the problems, the more we had questions and ideas. Priorities and strategies were becoming vital in that phase. We determined to meticulously work only on specific features that support the customer's main journey. 
                        <br/><br/>
                        Customers use the mobile app to book, find couriers around them, pick up the item and deliver it. It seems pretty straight-forward, yet it wasn't that simple to pinpoint the actual needs, pain points and make sure the experience we provide on each journey is on point. Through numerous iterations, we refined the experience on the booking journey based on feedback from customers once they finished their delivery.
                        </Medium>
                    </article>
                </Fade>
                <div className="cf"></div>
            </SectionOuter>

            <SectionOuter className="w-100-ns mt4-ns mt3-m mt0">
                <Fade bottom duration={800} distance={"2em"}>
                <img src={withPrefix('/img/etobee/etobee2.png')} className="pv3 db no-underline black"/>
                </Fade>
            </SectionOuter>

            <SectionOuter className="pt5-ns pb4-ns w-100-ns pv4-m pt3 pb3">
                <Fade bottom duration={800} distance={"2em"}>
                    <article className="w-40-ns w-100-m tl fl pr5-ns pb4-ns pb2-m pb0">
                        <Title3 className="mb4">An Android app for couriers.</Title3>
                    </article>

                    <article className="w-60-ns w-100-m fr mt0-ns fw3">
                        <Medium className="inconsolata alt-monospace fw3">Designing a mobile app for couriers was a unique experience for me. I think it was the first time for me designing mostly for people with low-tech. I was made several times not to believe that there were several user interfaces that should generally be used but failed to understand by them.
                        <br/><br/>
                        The app is pretty much simple. It does a job for couriers to receiver orders, follow the steps and confirm the status in each step. The challenging part was making sure that every part of the interface is easy and fast to understand. Empathy was our currency.
                        </Medium>
                    </article>
                </Fade>
                <div className="cf"></div>
            </SectionOuter>

            <SectionOuter className="pt5-ns pb4-ns w-100-ns pv4-m pt3 pb3">
                <Fade bottom duration={800} distance={"2em"}>
                    <article className="w-40-ns w-100-m tl fl pr5-ns pb4-ns pb2-m pb0">
                        <Title3 className="mb4">A transport management system for logistic partners.</Title3>
                    </article>

                    <article className="w-60-ns w-100-m fr mt0-ns fw3">
                        <Medium className="inconsolata alt-monospace fw3">
                        Etobee creates a partnership with logistics companies to enable their couriers for getting orders from our platform. Within the partnership, we provide a web-based application called Transport Management System (TMS) for them to control and monitor orders, couriers, and income.</Medium>
                    </article>
                </Fade>
                <div className="cf"></div>
            </SectionOuter>

            <SectionOuter className="pt5-ns pb6-ns pt5-m pb4-m pt3 pb4 mb4 w-100-ns">
                <Fade bottom duration={1000} distance={"2em"}>
                    <article className="w-100-ns tc-ns tl tl-m mb4-ns mb4-m mb3">
                        <Large>The result</Large>
                    </article>

                    <article className="w-100-ns mt2-ns fw3 ph5-ns ph0-m ph0">
                        <Medium className="inconsolata alt-monospace fw3 tc-ns tl tl-m lh-copy">For almost eight months (from July 2015 to March 2016) I helped Etobee to design all three touch points: a mobile app for users, a mobile app for drivers and a transport management system. I was also involved in several projects for their brand activation campaign and event.<br/><br/> As time goes by, Etobee continues to grow and integrate their logistics services with financial services. As time goes by, Etobee continues to grow and integrate their logistics services with financial services. Then, in 2018, they also changed their name to Finfleet.</Medium>
                    </article>
                    <div className="cf"></div>
                </Fade>
            </SectionOuter>

            <SectionOuter><Divider/></SectionOuter>

            <SectionOuter className="ph6-ns pt5-ns mb0-m pt4-m pb0-m ph5-m ph4 pt4 pb0 w-100-ns page-work">
                <Large className="mb3">Next</Large>
                <Fade left duration={500} distance={"3em"}>
                    <WorkListEnd className="bn">
                        <h1 className="f-buddy fw7 sans-serif fl bukalapak c--black1 mt0 mb0">
                            <AniLink cover to="bukalapak#section1" bg="#D21F4F" direction="down" duration={0.8}>
                            Taking the lead on the early product design team for a fast-growing marketplace
                            </AniLink>
                        </h1>               
                        <WorkListClient>
                            <Small className="fr-ns fl flex sans-serif">Bukalapak</Small>
                        </WorkListClient>
                        <div className="cf"></div>
                    </WorkListEnd>
                </Fade>
            </SectionOuter>

            <div className="cf"></div>
            <Footer/>

        </div>
      )
    }
  }
  
  export default Etobee